import { SelectOption } from 'components/Forms';
import { InsuranceType } from 'domains/signup/data/types';
import { TypeInsurance, TypeInsuranceFields } from 'types/contentful';
import ContentService from 'utils/contentful/contentfulService';
import { StateAbbrev, stateMapping } from 'utils/states';
import { fromPromise } from 'xstate';

export const NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION_V4: SelectOption = {
  label: 'Other',
  value: 'other',
};

export const MAX_INCLUDE_INSURANCE_OPTIONS_V4 = 10;

export interface AcceptedInsurancesV4 {
  entries: TypeInsuranceFields[];
  options: SelectOption[];
}
export const getAcceptedInsurancesV4 = async (
  stateCode: StateAbbrev,
  insuranceType: InsuranceType,
): Promise<AcceptedInsurancesV4> => {
  return ContentService.clients.expressable
    .getEntries<TypeInsurance>({
      content_type: 'insurance',
      'fields.state[match]': stateMapping[stateCode]
    })
    .then(({ items }) => {
      if (!items || items.length === 0) {
        throw new Error(`No ${insuranceType} providers found for state code ${stateCode}`);
      } else {
        return items
      }
    })
    //@ts-expect-error the SDk is throwing a wrong type definition
    // i.e for eaccesing the properties of a entry, the type definition 
    // expect to be `entry.fields.fields` instead of entry.fields
    .then((entries: TypeInsurance[]) => {
      const options: SelectOption[] = entries
        .filter(entry => entry.fields.insuranceType.toLowerCase() === insuranceType.toLowerCase())
        .filter(entry => entry.fields.accessibleByClients)
        .map(entry => ({
          label: entry.fields.friendlyPayerName.replace(/\s+/g, ' ').trim(),
          value: entry.fields.payerId,
        })).sort((a, b) => a.label.localeCompare(b.label));

      options.push(NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION_V4);

      const mappedEntries = entries.map(entry => ({ ...entry.fields }));

      return { entries: mappedEntries, options };
    });
};

export const getMedicaidProviderListLogicV4 = fromPromise(async ({ input }) => {
  const { state, insuranceType } = (input as { data: { state: string; insuranceType: InsuranceType } }).data;

  if (!state) {
    throw new Error('No state code in context');
  }

  return getAcceptedInsurancesV4(state as StateAbbrev, insuranceType);
});
